Ext.define('SA.DmaList', {
    alias: 'widget.sidebar-dma-list',
    extend: 'Ext.Component',

    cls: 'sa-sidebar-dma-list',

    tpl: [
        '<tpl for=".">',
            '<div class="sa-sidebar-dma-list-item<tpl if="selected"> sa-sidebar-dma-list-item-selected</tpl>" data-locationSeries="{locationSeries:htmlEncode}">',
                '{name:htmlEncode}',
            '</div>',
        '</tpl>'
    ],

    initEvents() {
        this.callParent();

        this.getEl().on('click', this.onClickItem, this, {delegate: '.sa-sidebar-dma-list-item'});
    },

    onClickItem(ev) {
        var item = ev.getTarget(),
            locationSeries = item.getAttribute('data-locationSeries');

        this.setSelected(locationSeries);

        this.fireEvent('select', this, locationSeries);
    },

    refresh() {
        if (!SA.data.DmaLocations.all) {
            return;
        }

        var data = SA.data.DmaLocations.all
            .filter(dma => dma.geographicReleases.includes(this.geographicRelease))
            .map(dma => Object.assign({}, dma, {name: dma.name.replace(/ \(DMA\)$/, ''), selected: dma.locationSeries === this.selected}))
            .filter(dma => !this.filterText || dma.name.toLowerCase().includes(this.filterText.trim().toLowerCase()));

        this.update(data);
    },

    setFilterText(filterText) {
        this.filterText = filterText;

        this.refresh();
    },

    setGeographicRelease(geographicRelease) {
        this.geographicRelease = geographicRelease;

        this.refresh();
    },

    setSelected(locationSeries) {
        this.selected = locationSeries;

        this.refresh();
    }
});